import React from 'react'

const ArrowRight = props => (
  <svg width='1em' height='1em' viewBox='-1 -1 15 17' {...props}>
    <path d='M14.78 7.03L9 12.81l-1.06-1.06 4.5-4.5H-.75a.75.75 0 1 1 0-1.5h13.19l-4.5-4.5L9 .19l5.78 5.78a.75.75 0 0 1 0 1.06z' />
  </svg>
)

export default ArrowRight
